(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/tabs/views/content-container_partial.js') >= 0) return;  svs.modules.push('/components/components/tabs/views/content-container_partial.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.tabs=_cmps.tabs||{};
_cmps.tabs.partials=_cmps.tabs.partials||{};
svs.components.tabs.partials.content_container = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"js-tabs-content tabs-content slider-container\">\n  <div class=\"js-slider-wrapper slider-wrapper slider-wrapper-toggle\">\n    "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":15}}}) : helper)))
    + "\n  </div>\n</div>";
},"useData":true});
Handlebars.partials['components-tabs-content_container'] = svs.components.tabs.partials.content_container;
})(svs, Handlebars);


 })(window);